import { TranslateService } from '@ngx-translate/core';
import { CompanyType } from '@iss/libs/graphql';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { BaseEnumTranslationPipe } from '@iss/wo-common/pipes';

@Pipe({ name: 'companyType', pure: false, standalone: true })
export class CompanyTypePipe extends BaseEnumTranslationPipe<CompanyType> implements PipeTransform {
  protected readonly translationPrefix = 'iss-mc.enum.company-type';

  public constructor(
    translateService: TranslateService,
    changeDetectorRef: ChangeDetectorRef,
  ) {
    super(translateService, changeDetectorRef);
  }
}
